import { jsx } from "react/jsx-runtime";
import { CheckboxGroupFieldWUT } from "../../../ui/checkbox-group-field/checkbox-group-field-wut.js";
import { FIELD_TYPES } from "../../../constants/field-types.js";
const CheckboxGroupWUT = (props) => {
  const { fieldType = FIELD_TYPES.CHECKBOX_GROUP } = props;
  return /* @__PURE__ */ jsx(CheckboxGroupFieldWUT, { ...props, fieldType });
};
export {
  CheckboxGroupWUT
};
//# sourceMappingURL=checkbox-group-wut.js.map
